import { defineStore } from "pinia";
import { ref } from "vue";
import svc from "@/services/boards.service";
import { toast } from "@/utils/toast";

export const useBoardStore = defineStore("board", () => {
  const items = ref([]);
  const current = ref(null);
  const loading = ref(false);

  // src/stores/boardStore.js
  async function list(params = {}) {
    loading.value = true;
    try {
      const query = { with_counts: 1, ...params };
      const { data } = await svc.list(query);
      const arr = data?.data || data || [];
      items.value = arr;
      if (current.value === undefined) current.value = null;
    } catch (e) {
      toast(
        e?.response?.data?.message || e.message || "Failed to load boards",
        "error"
      );
    } finally {
      loading.value = false;
    }
  }

  async function create(payload) {
    const { data } = await svc.create(payload);
    const b = data?.data || data;
    items.value.unshift(b);
    current.value = b;
    toast("Board created", "success");
    return b;
  }

  async function update(id, payload) {
    const { data } = await svc.update(id, payload);
    const b = data?.data || data;
    const idx = items.value.findIndex((x) => x.id === id);
    if (idx !== -1) items.value.splice(idx, 1, b);
    if (current.value?.id === id) current.value = b;
    toast("Board updated", "success");
    return b;
  }

  async function remove(id) {
    await svc.remove(id);
    items.value = items.value.filter((x) => x.id !== id);
    if (current.value?.id === id) current.value = items.value[0] || null;
    toast("Board deleted", "success");
  }

  function setCurrent(board) {
    current.value = board;
  }

  return { items, current, loading, list, create, update, remove, setCurrent };
});
